import { forwardRef } from 'react'

import style from './style.scss'

type Ref = HTMLDivElement

type Props = {
  children: React.ReactNode
}

const Comments = forwardRef<Ref, Props>(({ children }: Props, forwardedRef) => {
  return (
    <div ref={forwardedRef} className={style.wrapper}>
      {children}
    </div>
  )
})

export default Comments
